import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from '../axiosapi';

export const AuthContext = React.createContext();

const AuthContextProvider = (props) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [streakUpdated, setStreakUpdated] = useState(false);
  const [isNoticeRead, setIsNoticeRead] = useState(false);
  let serverUrl = process.env.REACT_APP_SERVER_URL;

  const loadUser = async () => {
    return axiosInstance({
      method: 'get',
      url: `${serverUrl}/check`,
    })
      .then((res) => {
        if (res.data.user) {
          setCurrentUser(res.data.user);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    loadUser();
  }, []);

  const requestReset = (data) => {
    return axiosInstance({
      method: 'post',
      url: `${serverUrl}/auth/login`,

      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      data: data,
    });
  };

  const login = (data, history) => {
    return axiosInstance({
      method: 'post',
      url: `${serverUrl}/api/v2/auth/login`,
      data: data,
    })
      .then((res) => {
        if (!res.data.verified) {
          toast.error('Please verify your phone number to login');
          return;
        }
        if (res.data.token) {
          window.localStorage.setItem('token', res.data.token);
          setCurrentUser(res.data.user);
          history.replace('/');
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const updateProfile = async (data, moduleId) => {
    let res = await axiosInstance({
      method: 'post',
      url: `${serverUrl}/${moduleId}/profile/`,
      data,
    });
    if (res.data.user) {
      setCurrentUser(res.data.user);
    }
    return res.data;
  };

  const updateCurrentUser = (currentUser) => {
    setCurrentUser(currentUser);
  };

  const logout = async () => {
    window.localStorage.setItem('token', null);
    setCurrentUser(null);
  };

  const verifyUser = (data, history) => {
    axiosInstance({
      method: 'post',
      url: `${serverUrl}/auth/verify`,

      data: data,
    }).then((res) => {
      if (res.data.token) {
        window.localStorage.setItem('token', res.data.token);
        setCurrentUser(res.data.user);
        history.replace('/');
      }
    });
  };

  const verifyReset = (data, setVerified) => {
    axiosInstance({
      method: 'post',
      url: `${serverUrl}/auth/verify`,

      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      data: data,
    })
      .then((res) => {
        if (res.data.token) {
          window.localStorage.setItem('token', res.data.token);
          setVerified(true);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        loading,
        login,
        logout,
        updateProfile,
        updateCurrentUser,
        loadUser,
        verifyUser,
        streakUpdated,
        setStreakUpdated,
        isNoticeRead,
        setIsNoticeRead,
        requestReset,
        verifyReset,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const state = useContext(AuthContext);
  return state;
};

export default AuthContextProvider;
